export default __webpack_public_path__ + "static/media/wheelchair_outline.a6e2148d.svg";